import { QueryClient } from "@tanstack/react-query";
import { USERS_QUERIES } from "~/shared/api/users/users.queries";

export function accountSkillsViewLoader(queryClient: QueryClient) {
  queryClient.prefetchQuery(USERS_QUERIES.profile());

  return null;
}
